import React, { useEffect, useState } from 'react'
import "./login.css" ; 
import LogoPic from "./../../Images/logo - png.png" ; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import lockPic from "./../../Images/padlock.png"
import {  useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAuthData, getDataUser, loginAPI } from '../../RTK/Slice/Auth/AuthSlice';
import back1 from "./../../Images/logo - png.png" ; 
import { validEmail as validEmailConst } from '../../Validation';
import { validPassword as validPasswordConst } from '../../Validation';
import { STATUS } from '../../Constants';

const LoginPage = () => {

    // For Show Input password
    const [showPass ,setShowpass] = useState(false) ;

    // For Change Route 
    const navigate = useNavigate();

    // For check focus (emaild field)
    const [focusEmail , setFoucsEmail] = useState(false) ;

    
    // For check focus (password field)
    const [focusPassword , setFoucsPassword] = useState(false) ;


    


    // For Check Login
    const isAuth = useSelector(getDataUser) ; 
    const {status} = useSelector(getAuthData) ; 


    useEffect(()=>{
        if(isAuth){
            navigate("/" , {replace : true})
        }
    } , [navigate , isAuth]);

    // For Dispatch Action
    const dispatch = useDispatch() ;
    
    // For Access Input
    const [email , setEmail] = useState('') ; 
    const [password , setPassword] = useState('') ; 

    // For Make Validation
    const [validEmail , setValidEmail] = useState('idle') ; // idle || success || failed
    const [validPassword , setValidPassword] = useState('idle' ) ; // idle || success || failed

    
    // For Handle Email
    const writeEmailHandler = (e)=>{
        setEmail(e.target.value)
        if(e.target.value === '' || e.target.value.length < 2){
            setValidEmail('idle')
        }else if(e.target.value.length > 11 && validEmailConst(e.target.value) ){
            setValidEmail('success')
        }else{
            setValidEmail('failed')
        }
    }

    // For Handle Email
    const writePasswordHandler = (e)=>{
        setPassword(e.target.value)
        if(e.target.value === '' || e.target.value.length < 2){
            setValidPassword('idle')
        }else if(e.target.value.length >= 8 && validPasswordConst(e.target.value) ){
            setValidPassword('success')
        }else{
            setValidPassword('failed')
        }
    }

    // For Login 
    const loginHandler = (e)=>{
        e.preventDefault(); 
        if(validEmail === 'success' && validPassword === 'success'){
            dispatch(loginAPI({email , password})) ; 
            navigate("/", { replace: true });

        }
    }

    
  return (
    <div className='main-login .my-font'>
            <div className='left'>
                <div className='sub-left'>
                <div className='head'>
                    <div className='image'><img src={LogoPic} alt='logo' /></div>
                    <h1>RBM</h1>
                    
                </div>
                <h2>Log in to your Account </h2>
                <p className='sub-title'>Welcome back!</p>
                <form onSubmit={loginHandler} className='login-form'>

                    <div className={`input-field ${validEmail === 'failed' ? 'unvalid-input' : ''} ${focusEmail ? 'input-field-active' : ""} `}>
                        <span style={{fontSize : "21px" , color : "gray"}} className="material-symbols-outlined">
                        mail
                        </span>
                        <input autoFocus onFocus={()=>setFoucsEmail(true)} onBlur={()=>setFoucsEmail(false)} value={email} onChange={writeEmailHandler} placeholder='Email' />
                    </div>

                    <p className={`valid-message ${validEmail ==='failed' ? 'valid-active-message' : ""}`} style={{fontSize : '10px'}}>Please Enter Valid Mail..</p>

                    

                    <div className={`input-field input-pass ${validPassword === 'failed' ? 'unvalid-input' : ""} ${focusPassword ? 'input-field-active' : ""} `} >
                        <div className='left'>
                            <img src={lockPic} alt='lockpng' />
                            <input onFocus={()=>setFoucsPassword(true)} onBlur={()=>setFoucsPassword(false)} value={password} onChange={writePasswordHandler} type={showPass ?"text"  :"password"} placeholder='Password' />
                        </div>
                        <div className='right-input' style={{cursor : "pointer"}} onClick={()=>setShowpass(!showPass)}>
                            <FontAwesomeIcon icon={ showPass ?  faEyeSlash: faEye} />
                        </div>
                    </div>
                    <p className={`valid-message ${validPassword ==='failed' ? 'valid-active-message' : ""}`} style={{fontSize : '10px'}}>Please Enter Valid Password..</p>

                    <div>
                        {/*<Link to={"/fogetpassword"} className='forget-password'>Forget Password</Link>*/}
                    </div>
                    <button  className='btn-login'> {status === STATUS.LOADDING ? <div className='fa-spin cricle-lodding'></div> : "Log in"} </button>
                </form>
                </div>
            </div>



        <div className='right' style={{display : "flex" , justifyContent :"center" , alignItems : "center"}}>
            <img className='logo-main' src={back1} alt='sdf' />
            <div className='rotate-roll'></div>
        </div>
    </div>
  )
}

export default LoginPage
